import { useEffect, useRef, useState } from 'react'

const VARIANT_SUCCESS_TIMEOUT = 2000

export const useCoreVariantsWebsocketCallbacks = () => {
  const refreshTimeoutRef = useRef<NodeJS.Timeout | undefined>(undefined)
  const moreLikeThisTimeoutRef = useRef<NodeJS.Timeout | undefined>(undefined)

  const [refreshSuccessVariantIds, setRefreshSuccessVariantIds] = useState<
    string[]
  >([])
  const [moreLikeThisSuccessVariantIds, setMoreLikeThisSuccessVariantIds] =
    useState<string[]>([])

  const onRefreshSuccess = (variantId: string) => {
    setRefreshSuccessVariantIds((prev) => [...prev, variantId])
    refreshTimeoutRef.current = setTimeout(() => {
      setRefreshSuccessVariantIds((prev) =>
        prev.filter((id) => id !== variantId)
      )
    }, VARIANT_SUCCESS_TIMEOUT)
  }

  const onMoreLikeThisSuccess = (variantId: string) => {
    setMoreLikeThisSuccessVariantIds((prev) => [...prev, variantId])
    moreLikeThisTimeoutRef.current = setTimeout(() => {
      setMoreLikeThisSuccessVariantIds((prev) =>
        prev.filter((id) => id !== variantId)
      )
    }, VARIANT_SUCCESS_TIMEOUT)
  }

  useEffect(() => {
    return () => {
      if (refreshTimeoutRef.current) {
        clearTimeout(refreshTimeoutRef.current)
      }
      if (moreLikeThisTimeoutRef.current) {
        clearTimeout(moreLikeThisTimeoutRef.current)
      }
    }
  }, [])

  return {
    refreshSuccessVariantIds,
    moreLikeThisSuccessVariantIds,
    onRefreshSuccess,
    onMoreLikeThisSuccess,
  }
}
